import React, { useCallback } from 'react';
import { IconArrowRightRegular, IconCloseRegular, LogoZdeliverySymbol } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { useIntersect } from '@common/hooks';
import { Typography } from '@common/styles';
import { PdpFloatingBannerIconType } from '@domains/pdp-common';

interface BannerProps {
  text: string;
  icon_type: PdpFloatingBannerIconType | null;
  handleLinkButton: () => void;
  handleCloseButton: () => void;
  onImpression: () => void;
}

export const FloatingZigzinBanner: React.FC<React.PropsWithChildren<BannerProps>> = ({
  text,
  icon_type,
  handleLinkButton,
  handleCloseButton,
  onImpression,
}) => {
  const intersectionObserverCallback = useCallback((entry) => {
    if (entry.isIntersecting) {
      onImpression();
    }
  }, []);

  const { targetRef } = useIntersect(intersectionObserverCallback);

  return (
    <Container ref={targetRef}>
      <Link className={Typography.BODY_13_SEMIBOLD} onClick={handleLinkButton}>
        {icon_type === PdpFloatingBannerIconType.ZIGZIN && <LogoZdeliverySymbol width={18} height={12} />}
        <Text dangerouslySetInnerHTML={{ __html: text }} />
        <IconArrowRightRegular color='purple400' strokeWidth={1.5} size={16} />
      </Link>
      <CloseButton type='button' onClick={handleCloseButton}>
        <IconCloseRegular v3Color='gray400' width={20} height={20} />
      </CloseButton>
    </Container>
  );
};

const Container = styled.div`
  padding: 9px 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${vars.color.purple50};
  border-top: 1px solid ${vars.color.purple100};
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.04);
`;

const Link = styled.div`
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  margin: 0 0 0 4px;
  color: ${vars.v3Color.purple500};
`;

const CloseButton = styled.button`
  margin: 0 0 0 16px;
  position: relative;
  right: -3px;
  width: 20px;
  height: 20px;
`;
